export default __webpack_public_path__ + "static/media/nu.7a54f93b.svg";